import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';

import mainSprite from '../../assets/images/main_sprites.png';
import { fadeIn, spinning } from '../../styles/animations';
import theme from '../../styles/theme';
import { screenMedium, screenSmall } from '../../styles/theme/breakpoints';
import { rem } from '../../styles/theme/layout';
import { center } from '../../styles/utils';

const outerWrapper: SerializedStyles = css`
  position: fixed;
  bottom: -100%;
  opacity: 0;
  transition: all 1s ease-in-out;
  width: 100%;
`;

const openPlayer: SerializedStyles = css`
  bottom: 0;
  opacity: 1;
  transition: all 1s ease-in-out;
`;

const wrapper: SerializedStyles = css`
  background: ${theme.colors.audioPlayerBg};
  color: white;
  padding: ${rem(10)};
`;

const contentWrapper: SerializedStyles = css`
  max-width: ${theme.layout.containerMaxWidth};
  margin: 0 auto;
  justify-content: space-between;
`;

const metaWrapper: SerializedStyles = css`
  width: 25%;
  @media screen and (max-width: ${screenMedium}) {
    display: none;
  }
`;

const descWrapper: SerializedStyles = css`
  /* min-width: ${rem(270)}; */
  @media screen and (max-width: ${screenSmall}) {
    display: none;
  }
`;

const nispButton: SerializedStyles = css`
  position: relative;
  text-align: center;
  cursor: pointer;
  display: block;
  width: 60px;
  margin: 0;
  height: 60px;
  opacity: 0.8;
  background-color: transparent;
  border: 0;
  outline: none;
  transition: opacity 0.3s;
  &:hover {
    opacity: 1;
  }
`;

const loading: SerializedStyles = css`
  position: absolute;
  ${center};
  height: ${rem(42)};
  width: ${rem(42)};
  animation: ${fadeIn} 0.7s;
  &:after {
    z-index: 2;
    content: '';
    border-right: 5px solid #777;
    border-top: 5px solid #777;
    border-left: 5px solid #999;
    border-bottom: 5px solid #bbb;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    display: block;
    animation: ${spinning} 0.75s infinite linear;
    position: relative;
    left: -7px;
    top: -5px;
  }
`;

const spriteElement: SerializedStyles = css`
  background: url('${mainSprite} ') no-repeat;
  display: block;
  margin: 0 auto;
`;

const playButton: SerializedStyles = css`
  ${spriteElement}
  background-position: -906px -50px;
  width: 13px;
  height: 22px;
`;

const pauseButton: SerializedStyles = css`
  ${spriteElement}
  background-position: -946px -50px;
  width: 16px;
  height: 20px;
`;

const prevButton: SerializedStyles = css`
  ${spriteElement}
  background-position: -826px -50px;
  width: 17px;
  height: 16px;
`;

const nextButton: SerializedStyles = css`
  ${spriteElement}
  background-position: -866px -50px;
  width: 17px;
  height: 16px;
`;

const closeButton: SerializedStyles = css`
  ${spriteElement}
  background-position: -986px -50px;
  width: 18px;
  height: 18px;
`;

const trackTitle: SerializedStyles = css`
  font-size: ${theme.fontSizes[0]};
`;

const miniPlayTime: SerializedStyles = css`
  text-align: center;
  font-size: ${theme.fontSizes[0]};
  @media screen and (min-width: ${screenMedium}) {
    display: none;
  }
`;

const waveForm: SerializedStyles = css`
  height: 50%;
  cursor: pointer;
  padding: 0;
  background-size: 100% 80px;
  background-position: 0 -10px;
  background-repeat: no-repeat;
  position: relative;
`;

const playhead: SerializedStyles = css`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 1px;
  background: ${theme.colors.white};
  transition: all 0.3s;
`;

const transportBar: SerializedStyles = css`
  background: ${theme.colors.black};
  position: absolute;
  top: 0;
  left: 1px;
  font-size: ${rem(10)};
  min-width: ${rem(50)};
  text-align: center;
`;

export default {
  outerWrapper,
  openPlayer,
  wrapper,
  contentWrapper,
  metaWrapper,
  descWrapper,
  nispButton,
  playButton,
  pauseButton,
  prevButton,
  nextButton,
  closeButton,
  trackTitle,
  waveForm,
  loading,
  playhead,
  transportBar,
  miniPlayTime,
};
